import React from 'react';

import Table from 'components/Table';
import EditButton from 'components/ActionButtons/editButton';
import DeleteButton from 'components/ActionButtons/deleteButton';
import { t } from 'i18next';
import dayjs from 'dayjs';
function List({ headers, data, onEdit, buttons, onDelete }) {
  return (
    <Table
      subtitle={t('position')}
      title={t('sidebar.information')}
      headers={headers.map((e) => (
        <th scope='col' key={`thead-${Math.random()}`}>
          {t(e)}
        </th>
      ))}
      data={data}
      buttons={buttons}
      rows={data.map((e, index) => (
        <tr key={`table-row-${Math.random()}`}>
          <td>{index + 1}</td>
          <td>{e.departure?.name}</td>
          <td>{e.destination?.name}</td>
          <td>{e.itemtype?.name}</td>
          <td>{e.cargo_type}</td>
          <td>{e.unit}</td>
          <td>
            {e.limit} {e.value}
          </td>
          <td>{e.shipment_type?.name}</td>
          <td>{e.shipping_mode?.name}</td>
          <td>{dayjs(e.update_value_date).format('DD/MM/YYYY')}</td>
          <td>{e.basic_freight_value}</td>
          <td>
            <EditButton onClick={() => onEdit(e)} />
            <DeleteButton onClick={() => onDelete(e)} />
          </td>
        </tr>
      ))}
    />
  );
}

export default List;
